module.exports = __webpack_public_path__ + "static/media/main.bc53839.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/SAMURAISHODOWN/top/main.mp4
// module id = eShj
// module chunks = 0